/*
 * bundle-gallery-sync.js  (v8 - FINAL)
 * ---------------------------------------------------------------------------
 * v8-Fix:
 *   v7 blockierte das Umschalten, weil der Media-ID-Vergleich fälschlich
 *   "schon gesetzt" meldete. Jetzt merken wir uns einfach die zuletzt
 *   VERARBEITETE Kombination "aktive-Stufe + Farbe". Ändert sie sich,
 *   schalten wir GENAU EINMAL. Kein Flackern (weil pro Kombi nur einmal),
 *   und kein Blockieren (weil kein fragiler ID-Vergleich).
 *   Weiterhin: kein Scrollen, Match über Bild-URL, rekursive Shadow-Suche.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var colorToBasename = {};
  var ready = false;
  var lastKey = null;   // "s1kF|weiß"

  function normalize(s) { return (s == null ? '' : String(s)).trim().toLowerCase(); }

  function basename(url) {
    if (!url) return '';
    var clean = String(url).split('?')[0];
    var file = clean.substring(clean.lastIndexOf('/') + 1);
    file = file.replace(/\.[a-z0-9]+$/i, '');
    file = file.replace(/_\d+x\d*$/i, '');
    return normalize(file);
  }

  function deepQueryAll(selector, root, acc) {
    root = root || document;
    acc = acc || [];
    try { root.querySelectorAll(selector).forEach(function (e) { acc.push(e); }); } catch (e) {}
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) deepQueryAll(selector, all[i].shadowRoot, acc);
    }
    return acc;
  }

  function getHandle() {
    var m = window.location.pathname.match(/\/products\/([^\/\?#]+)/);
    if (m && m[1]) return m[1];
    try { return window.ShopifyAnalytics.meta.product.handle || null; }
    catch (e) { return null; }
  }

  function loadProductData() {
    var handle = getHandle();
    if (!handle) return;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (base.charAt(base.length - 1) !== '/') base += '/';
    fetch(base + 'products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        if (!product || !product.variants) return;
        buildMap(product);
        ready = true;
      })
      .catch(function () {});
  }

  function buildMap(product) {
    var colorIndex = -1;
    if (product.options && product.options.length) {
      for (var i = 0; i < product.options.length; i++) {
        var n = normalize(product.options[i].name || product.options[i]);
        if (n.indexOf('farbe') !== -1 || n.indexOf('color') !== -1 || n.indexOf('colour') !== -1) {
          colorIndex = i; break;
        }
      }
    }
    product.variants.forEach(function (v) {
      var src = v.featured_image && v.featured_image.src;
      if (!src) return;
      var bn = basename(src);
      if (!bn) return;
      var opts = v.options ||
        [v.option1, v.option2, v.option3].filter(function (x) { return x != null; });
      if (colorIndex >= 0 && opts[colorIndex] != null) {
        colorToBasename[normalize(opts[colorIndex])] = bn;
      } else {
        opts.forEach(function (val) { if (val != null) colorToBasename[normalize(val)] = bn; });
      }
    });
  }

  function findMediaIdByBasename(bn) {
    if (!bn) return null;
    var imgs = document.querySelectorAll('.product__media-list img, media-gallery img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var candidate = img.currentSrc || img.src ||
        img.getAttribute('data-src') || img.getAttribute('srcset') || '';
      if (basename(candidate.split(' ')[0]) === bn) {
        var holder = img.closest('[data-media-id]');
        if (holder) return holder.getAttribute('data-media-id');
      }
    }
    return null;
  }

  // Wechselt das Galeriebild OHNE zu scrollen.
  function switchTo(mediaId) {
    if (mediaId == null) return;
    var gallery = document.querySelector('media-gallery');
    var el = document.querySelector('.product__media-list [data-media-id="' + mediaId + '"]')
          || (gallery && gallery.querySelector('[data-media-id="' + mediaId + '"]'));
    if (!el) return;

    var sx = window.scrollX, sy = window.scrollY;

    if (gallery && typeof gallery.setActiveMedia === 'function' && el.id) {
      try { gallery.setActiveMedia(el.id, false); restoreScroll(sx, sy); return; } catch (e) {}
    }
    var list = el.closest('.product__media-list') || document;
    list.querySelectorAll('.product__media-item.is-active')
      .forEach(function (x) { x.classList.remove('is-active'); });
    var item = el.closest('.product__media-item') || el;
    item.classList.add('is-active');
    restoreScroll(sx, sy);
  }

  function restoreScroll(x, y) {
    window.scrollTo(x, y);
    requestAnimationFrame(function () { window.scrollTo(x, y); });
    setTimeout(function () { window.scrollTo(x, y); }, 0);
    setTimeout(function () { window.scrollTo(x, y); }, 60);
  }

  // Aktive Stufe (checked radio) + deren erste Farbe. Gibt {key, color}.
  function readActive() {
    var options = deepQueryAll('.bundle-option');
    var activeOption = null;
    var activeKey = '';
    for (var i = 0; i < options.length; i++) {
      var radio = options[i].querySelector('input[type="radio"]');
      if (radio && radio.checked) { activeOption = options[i]; activeKey = radio.value || String(i); break; }
      if (options[i].classList &&
          (options[i].classList.contains('is-selected') ||
           options[i].classList.contains('selected') ||
           options[i].classList.contains('active'))) {
        activeOption = options[i]; activeKey = 'cls' + i;
      }
    }
    if (!activeOption && options.length) { activeOption = options[0]; activeKey = 'first'; }
    if (!activeOption) return null;

    var pickers = deepQueryAll('section-store--product-option-picker', activeOption);
    for (var j = 0; j < pickers.length; j++) {
      var h = pickers[j];
      if (!h.shadowRoot) continue;
      var t = h.shadowRoot.querySelector('.rich-dropdown__trigger');
      if (!t) continue;
      var label = t.getAttribute('aria-label') || '';
      var idx = label.indexOf(':');
      var val = (idx !== -1 ? label.slice(idx + 1) : label).trim();
      if (!val) {
        var nameEl = t.querySelector('.rich-dropdown__value-name');
        if (nameEl) val = nameEl.textContent.trim();
      }
      if (val) return { key: activeKey, color: val };
    }
    return null;
  }

  function pollTick() {
    if (!ready) return;
    var a = readActive();
    if (!a) return;

    var key = a.key + '|' + normalize(a.color);
    if (key === lastKey) return;      // gleiche Stufe+Farbe -> nichts tun (kein Flackern)
    lastKey = key;                    // Kombi als verarbeitet merken

    var bn = colorToBasename[normalize(a.color)];
    if (!bn) return;
    var targetId = findMediaIdByBasename(bn);
    if (targetId != null) switchTo(targetId);
  }

  function init() {
    loadProductData();
    setInterval(pollTick, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();